import { Data } from './data';

export class Ad extends Data {
    class: string = "Ad";
    type: string;
    name: string;
    id: string;
    users: string[];
}